import qs from "qs";

/**
 * Persistent ID's used by Amwell include characters that are inappropriate for
 * URLs (eg "="), so we encode them here, for cases where we need to do so.
 * (EG: '/account/messages/messageId', for a message details screen.)
 */
export const parsePersistentMessageId = (id = "") => qs.stringify({ id }).split("id=")[1];
